define('models/GoogleAutocompleteModel',['underscore','jquery','backbone','app','router','ObjectModel','PlaceModel','string'],function (_,$,Backbone,app,router,ObjectModel,PlaceModel,S) {
    //
    // Google Address Autocomplete Model
    //

    // function onQuotaExceededError(){
    //     LocalStorage.removeAllItemsOfType(GooglePlaceModel.name);
    // }

    var _GOOGLE_PLACE_ADDRESS_ALLOWED_TYPES_ = false;
    function getAllowedPlaceTypes() {
        if(!_GOOGLE_PLACE_ADDRESS_ALLOWED_TYPES_){
            _GOOGLE_PLACE_ADDRESS_ALLOWED_TYPES_ = app.c('_GOOGLE_PLACE_ADDRESS_ALLOWED_TYPES_','street_address,route,premise').split(',');
        }
        return _GOOGLE_PLACE_ADDRESS_ALLOWED_TYPES_;
    }

    var GoogleAutocompleteModel = {
        name:'GoogleAutocompleteModel',
        idAttribute:'place_id',
        initialize:function(options){
            var model = this;
            ObjectModel.prototype.initialize.apply(model,options);
            //
            //
            //
            if(model.isLocalityMatching()){
                // si la localité match
                var place = model.getPlace(),
                    postcode,
                    id_postcode = place.get('id_postcode'),
                    id_district = place.get('id_district');
                place.on('sync',model.onPlaceSync,model);
                if(id_postcode){
                    // si on a déjà le code postal
                    postcode = place.getPostcode();
                    if(postcode.hasDistricts() && _.isUndefined(id_district)){
                        // si on a pas l'id_district, on essaye de l'obtenir
                        if(model.usePlaceFetch()){
                            place.fetch();
                        }
                    }
                }else if(model.usePlaceFetch()) {
                   place.fetch();
                }
            }
        },
        usePlaceFetch:function(){
            return this.get('usePlaceFetch') === true;
        },
        onPlaceSync:function(model){
            this.collection.trigger('placeSync',this.collection);
        },
        getPlace:function(){
            return PlaceModel.getPlace(this.id,this);
        },
        getDescription:function(){
            return this.get('description');
        },
        getLocality:function(){
            return this.getPlace().getLocality();  
        },
        isAddress:function(){
            return this.getTypes().intersection(getAllowedPlaceTypes()).length > 0;
        },
        isType:function(type){
            return this.getTypes().contains(type);
        },
        isRoute:function(){
            return this.isType('route');
        },
        isStreetAddress:function(){
            return this.isType('street_address');
        },
        isDeliveryAddress:function(){
            // vérifie si un résultat est livrable (VAD) ou non
            // seuls les types suivants street_address & route sont livrables
            return this.isAddress();
        },
        isStoreRadiusAvailable:function(){
            // vérifie si un résultat doit utiliser une approximation par distance
            // locality
            return this.isType('locality');
        },
        getTypes:function(){
            return _(this.get('types'));
        },

        isLocalityMatching:function(){
            //
            return this.getPlace().isLocalityMatching();
        },
        getStores:function(){
            return this.getPlace().getStores();
        },
        getRank:function(){
            var model = this,
                rank = model.collection.indexOf(model);
            if(model.isRoute()){
                // si c'est une rue, ça a moins de valeur
                rank+=5;
            }
            if(!model.isLocalityMatching()){
                // si ce n'est pas dans une ville déservi, ça a aussi moins de valeur
                rank+=10;
            }
            return rank;
        }
    };

    return ObjectModel
        .extend(GoogleAutocompleteModel);
});
